export default "__VITE_ASSET__DSM78iL9__"